
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class TownsDialog extends Serenity.EntityDialog<TownsRow, any> {
        protected getFormKey() { return TownsForm.formKey; }
        protected getIdProperty() { return TownsRow.idProperty; }
        protected getLocalTextPrefix() { return TownsRow.localTextPrefix; }
        protected getNameProperty() { return TownsRow.nameProperty; }
        protected getService() { return TownsService.baseUrl; }
        protected getDeletePermission() { return TownsRow.deletePermission; }
        protected getInsertPermission() { return TownsRow.insertPermission; }
        protected getUpdatePermission() { return TownsRow.updatePermission; }

        protected form = new TownsForm(this.idPrefix);

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CityCountryId,
                this.form.CityId
            ]);
        }
    }
}
